import { render, staticRenderFns } from "./customCategoriesUnit.vue?vue&type=template&id=cee2b3c4&scoped=true"
import script from "./customCategoriesUnit.vue?vue&type=script&lang=js"
export * from "./customCategoriesUnit.vue?vue&type=script&lang=js"
import style0 from "./customCategoriesUnit.vue?vue&type=style&index=0&id=cee2b3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee2b3c4",
  null
  
)

export default component.exports